<template>
  <EditCom
    title="底图服务导出"
    :target="target"
    :buttonList="buttonList"
    :inputList="inputList"
    :rules="rules"
    @closeFun="close"
  ></EditCom>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import EditCom from '@/components/EditCom';

import {
  exportFootPrintMap, exportMapEvent, exportOffline,
} from '@/api/ExportData';
// props
const props = defineProps({
  target: { type: Object, },
});
// emit
const emit = defineEmits([
  'close',
]);

const close = ()=>{
  emit('close');
}

const exportTypeList = [
  { label: 'geojson', value: '1' },
  // { label: 'shapefile(shp)', value: '3' },
  { label: 'URL', value: '4' },
  { label: '关联事件详情', value: '6' },
  { label: '相关离线数据', value: '7' },
]
const target = ref({
  ...props.target,
  exportTypeList: exportTypeList,
});

const submitFn = (item, button, loadFn, fn)=>{
  const exportVal = item['type'];
  let port;
  switch(exportVal){
    case '6': port = exportMapEvent;break;
    case '7': port = exportOffline;break;
    default: port = exportFootPrintMap;
  }

  port({
    id: item['id'],
    type: item['type'],
    exportName: item['exportName'],
  }).then(res=>{
    if(res.data.code == 1004){
      message(res.data.msg, 1);
      close();
    }
    loadFn && loadFn();
  }).catch(err=>{
    loadFn && loadFn();
    console.log(err);
  });
}
const submit = (form, item, button, loadFn, fn)=>{
  // console.log(form, item, button, loadFn, fn);
  form.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      submitFn(item, button, loadFn, fn);
    }else{
      loadFn && loadFn();
    }
  });
};

const buttonList = ref([
  { name: '取消', fun: close, type: 'danger', },
  { name: '确定', fun: submit, type: 'primary', },
]);
const inputList = ref([
  { name: '导出名称', prop: 'exportName', type: 'text', },
  // { name: '底图服务', prop: 'id', type: 'select', 
  //   select: {
  //     list: 'dataList',
  //     label: 'name',
  //     value: 'id',
  //   }
  // },
  { name: '导出文件类型', prop: 'type', type: 'select',
    select: {
      list: 'exportTypeList',
      value: 'value',
      label: 'label',
    }
  },
]);
const rules = reactive({
  exportName: [
    { required: true, message: '请输入导出名称', trigger: 'blur' },
  ],
  // id: [
  //   { required: true, message: '请选择底图服务', trigger: 'blur' },
  // ],
  type: [
    { required: true, message: '请选择文件类型', trigger: 'blur' },
  ],
});

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>